module.exports = __webpack_public_path__ + "static/media/gd32n.bc7e0d20.png";